<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { SUBSCRIBE_URL } from '@/data/links';
const { width } = useWindowSize();

// Попап показывается за сессию дважды: через 2 секунды после загрузки и,
// если его закрыли, ещё раз через минуту. После второго закрытия не возвращается.
const CLOSED_KEY = 'ruchoko-subscribe-popup-closed';
const DELAYS = [2000, 60000];

const isOpen = ref(false);
let timer = null;

// Счётчик закрытий живёт в sessionStorage: перезагрузка страницы не должна
// начинать показы заново.
const closedCount = () => Number(sessionStorage.getItem(CLOSED_KEY)) || 0;

const scheduleShow = () => {
  const delay = DELAYS[closedCount()];
  if (delay === undefined) return;
  timer = setTimeout(() => { isOpen.value = true }, delay);
};

const close = () => {
  isOpen.value = false;
  sessionStorage.setItem(CLOSED_KEY, closedCount() + 1);
  scheduleShow();
};

onMounted(scheduleShow);
onUnmounted(() => clearTimeout(timer));
</script>

<template>
  <div class="subscribe-popup" v-if="isOpen && width >= 1024">
    <img src="@/assets/img/bob7.webp" alt="" class="subscribe-popup__image"/>
    <div class="subscribe-popup__content">
      <div class="subscribe-popup__head">
        <h3 class="subscribe-popup__title">Полезная информация <br/>в нашей рассылке</h3>
        <a href="" class="subscribe-popup__close" @click.prevent="close">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 0.5L8.5 8.5L0.5 16.5M16.5 0.5L8.5 8.5L16.5 16.5" stroke="#642000" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </a>
      </div>
      <p class="subscribe-popup__text">Подпишитесь и получайте свежие <br/>новости и выгодные предложения</p>
    </div>
    <a
      :href="SUBSCRIBE_URL"
      class="subscribe-popup__button"
      target="_blank"
    >Подписаться</a>
  </div>
</template>
